import AsyncStorage from '@react-native-async-storage/async-storage';
import  { useEffect,useState } from 'react';
import { StyleSheet,  View,Image, Text,TouchableOpacity } from 'react-native';

const Select = ({onOpen}:{
  onOpen: (value:number) => void;
}) => {
  const [allItems, setAllItems] = useState(0);
  const checkLocalStorage = async () => {
    const storedArray = await AsyncStorage.getItem('randomArray');
    console.log('storedArray',storedArray)
    if (storedArray) {
        const parsedArray = JSON.parse(storedArray);
        const items:  number[] = parsedArray.array  ;
      
      setAllItems(items.length);
    }
    
  }
  useEffect(() => {
    checkLocalStorage().catch(() => {
    })
  
  },[])





return <View style={{...styles.container, }}>
    <View  style={{...styles.logoW, backgroundColor: '#099b43'}}>
      <Image
        style={styles.logo}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/logo.png')}
      />
    </View>
    <View  style={{...styles.containerw, marginTop: '6%', marginBottom: '5%'}}>
    <Image
          style={{
            ...styles.centerImage,
            width:427,
            height:245
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/txt-1.png')}
        />
</View>
<View>
    <View  style={styles.containerFlex}>
   
        <TouchableOpacity
          onPress={() => {
            if(allItems > 0)
            onOpen(1);
          }}
        >
          <Image
        style={styles.logoD}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/flavour/1.png')}
      />
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => {
            if(allItems > 0)

            onOpen(2);
          }}
        >
          <Image
        style={styles.logoD}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/flavour/2.png')}
      />
        </TouchableOpacity>


        <TouchableOpacity
          onPress={() => {
            if(allItems > 0)

            onOpen(3);
          }}
        >
          <Image
        style={styles.logoD}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/flavour/3.png')}
      />
        </TouchableOpacity>
</View>
<View  style={styles.containerFlex}>
   
   <TouchableOpacity
     onPress={() => {
      if(allItems > 0)

       onOpen(4);
     }}
   >
     <Image
   style={styles.logoD}
   resizeMode="contain"
   resizeMethod="resize"
   source={require('../assets/flavour/4.png')}
 />
   </TouchableOpacity>

   <TouchableOpacity
     onPress={() => {
      if(allItems > 0)

       onOpen(5);
     }}
   >
     <Image
   style={styles.logoD}
   resizeMode="contain"
   resizeMethod="resize"
   source={require('../assets/flavour/5.png')}
 />
   </TouchableOpacity>


   <TouchableOpacity
     onPress={() => {
      if(allItems > 0)

       onOpen(6);
     }}
   >
     <Image
   style={styles.logoD}
   resizeMode="contain"
   resizeMethod="resize"
   source={require('../assets/flavour/6.png')}
 />
   </TouchableOpacity>
</View>
</View>
    <View  style={styles.containerLast}>
        <Image
          style={{
            ...styles.centerImage,
            height: 74,
            width: 627
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/cups.png')}
        />
    <Text>{ allItems}</Text>
    </View>
  

  </View>
}

const styles = StyleSheet.create({
  container: {
    flex:1,
    width:'100%',
    minHeight:1080,
    backgroundColor: '#fff',
    flexGrow: 1,

  },
  logoW:{

    },
    logo:{
      alignSelf: 'center',
      width: 800,
      height:126,
    },
  containerLast:{
   backgroundColor:'#b8cd70',
    width:'100%',
    verticalAlign:'bottom',
    flex:1,
    flexDirection: 'column',
    paddingTop: '12%',
    height: 120,
    marginTop: '12%',
},
  containerw:{
    position:'relative',
    width:'100%',
    zIndex: 1,
  },
    logoD:{
    marginLeft: '2%',
    marginRight: '2%',
    width: 206,
    height: 206,
    },
    containerFlex:{
    flex:1,
    height: 210,
    position:'relative',
    width: '100%',
    alignItems:'center',
    zIndex: 1,
    marginTop: '7%',
    flexDirection: 'row',
    justifyContent:'center'
  },
  button:{
    backgroundColor:'#00a547',
    borderRadius: 7,
    alignSelf: 'center',
    flex:1,
    height: 60,

    width:280,
    marginBottom:'10%',
    marginTop:'4%',
    alignItems:'center',
    justifyContent:'center',
  },
  text:{
    fontSize: 42,
    color: '#fff',
    fontWeight: 'bold',
    alignSelf: 'center',
    marginTop:'10%',
    paddingBottom:'0%',
    lineHeight: 50,
    marginBottom:'1%',
    fontFamily: 'Agriculture',
  

  },
  centerImage:{
    alignSelf: 'center',
  },
  buttonText: {
    color: '#fff',
    fontSize: 34,

    fontFamily: 'Agriculture',
    textAlign: 'center',
  },
});
export default  Select;
